import { render } from "./scalequestionsview.vue?vue&type=template&id=3a344b08"
import script from "./scalequestionsview.vue?vue&type=script&lang=js"
export * from "./scalequestionsview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__